import { useRouter } from 'next/router';
import { useContext } from 'react';
import { Overlays } from 'ap-admin-components/lib/Components/Overlays';
import { OverlayType } from '@/lib/enums/OverlayType.enum';

export type OverlayTypeWithKey = `${OverlayType}-${string}`;

const useOverlayActions = () => {
  const router = useRouter();
  const { openOverlays, overlaysActions } = useContext(Overlays);

  const isOpen = (type: OverlayType | OverlayTypeWithKey) => openOverlays.includes(type);

  const open = (type: OverlayType | OverlayTypeWithKey) => {
    void router.push(`${router.asPath.split('#')[0]}#${type}`);
    overlaysActions({
      action: 'open',
      name: type,
    });
  };

  const closeAll = () => {
    if (!openOverlays.length) {
      return;
    }
    router.back();
  };

  return {
    open,
    closeAll,
    isOpen,
  };
};

export default useOverlayActions;
